import styled from 'styled-components'
import { Button } from 'antd'

export const ButtonEx = styled(Button)`
  ${(props) =>
    props.color &&
    `
      background-color: ${props.color};
      border-color: ${props.color};
    `}
`
